import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"
import { PostUserapiOrgCheckOrgApiResponse } from "../../app/services/meseeknaApi"
import { AuthState, Organization, Role, User } from "./types"

const initialState: AuthState = {
  organization: {},
  role: {},
  user: {},
  isAuthenticated: false,
  completedTutorial: false,
  testTitle: "",
} as AuthState

export const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    convertAndUpdateOrganization(
      state,
      action: PayloadAction<PostUserapiOrgCheckOrgApiResponse>,
    ) {
      if (action.payload === undefined) {
        state.organization = {} as Organization
      }
      const orgResult = action.payload as PostUserapiOrgCheckOrgApiResponse
      const status = orgResult.status || "fail"
      const data = orgResult.data || {}
      const respData = {
        status,
        ...data,
        // Ensure id is a string to match Organization type - but do NOT default to any value
        id: data.id ? String(data.id) : undefined,
      } as unknown as Organization
      respData.status = status
      state.organization = respData
    },
    updateOrganization(state, action: PayloadAction<Organization | undefined>) {
      if (action.payload === undefined) {
        state.organization = {} as Organization
      }
      state.organization = action.payload as Organization
    },
    setRole(state, action: PayloadAction<Role>) {
      state.role = action.payload
    },
    setLoggedInUser(state, action: PayloadAction<User>) {
      state.user = action.payload
    },
    setUserCompletedTutorial(state, action: PayloadAction<boolean>) {
      state.completedTutorial = action.payload
    },
    setIsAuthenticated(state, action: PayloadAction<boolean>) {
      state.isAuthenticated = action.payload
    },
    setToInitialState: () => initialState,
    setTestTitle(state, action: PayloadAction<string>) {
      state.testTitle = action.payload
    },
  },
})

export const authReducer = persistReducer(
  {
    key: "msk:auth",
    storage,
    whitelist: [
      "organization",
      "role",
      "user",
      "isAuthenticated",
      "completedTutorial",
      "testTitle",
    ],
  },
  authSlice.reducer,
)

export const {
  convertAndUpdateOrganization,
  updateOrganization,
  setRole,
  setLoggedInUser,
  setUserCompletedTutorial,
  setIsAuthenticated,
  setToInitialState,
  setTestTitle,
} = authSlice.actions

export default authSlice.reducer
